export default __webpack_public_path__ + "static/media/hero-image.cf7f7105.png";